import React from 'react';
import config from '../../client/config';
import { useTranslation } from 'react-i18next';
import Svg from '@justgiving/svg';
import { chevronLeftIcon } from '@justgiving/icons';

import styles from './SuccessMessage.scss';

export interface Props {
  title: string;
  editUrl: string;
  openModal: () => any;
}

const SuccessMessageEditBar: React.FunctionComponent<Props> = ({
  title,
  editUrl,
  openModal,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <div
      data-qa="success-message-edit-bar"
      className="container-fluid jg-background--white jg-bdb jg-bd--gainsboro jg-space-pmd"
    >
      <div className="container">
        <div>
          <div className="jg-display-ib">
            <Svg
              markup={chevronLeftIcon}
              className="jg-icon jg-fill--dark-orchid jg-display-ib"
            />
          </div>
          <div className={`jg-display-ib ${styles.dashboardUrl}`}>
            <a href={`${config.baseUri}/campaign/manage`}>
              {t('campaign.backToDashboard')}
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <h2 className="jg-space-mbn jg-space-ptxs jg-space-mtmd jg-campaign-success--title">
              {title}
            </h2>
          </div>
          <div className="col-md-6">
            <div className="row jg-space-mtmd">
              <div className="col-xl-6">
                <a href={editUrl} className="jg-btn jg-btn--ghost">
                  {t('campaign.editCampaign')}
                </a>
              </div>
              <div className="col-xl-6">
                <button
                  className="jg-btn jg-space-mtsm jg-space-mtn@xl"
                  onClick={openModal}
                >
                  {t('campaign.shareYourPage')}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={`jg-text--light ${styles.campaignLive}`}>
          {t('campaign.live')}
        </div>
      </div>
    </div>
  );
};

export default SuccessMessageEditBar;
